import { FaUsers, FaTools, FaCheckCircle, FaClock, FaChartLine, FaLeaf } from "react-icons/fa";
import { images } from '../constants'; 


const careerIntro = {
  sub: "Career with us",
  heading: "Join Our Laundry and Dry Cleaning Team",
  description:
    "At LaundryHub, we're building a team of dedicated professionals. Join us for a rewarding career in laundry and dry cleaning services. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
  points: [
    "Explore Career Opportunities in Laundry",
    "Assist in Laundry Operations and Outreach",
    "Laundry Skills Development Programs",
    "Equipment Maintenance and Quality Control",
    "Support in Emergency Laundry Operations",
  ],
    image: {
        src1: images.careerIntro1,
        src2: images.careerIntro2,
        src3: images.careerIntro3,
        alt1: "Career-Image-1",
        alt2: "Career-Image-2",
        alt3: "Career-Image-3",
    },
};



const benefits = [
    {
        id: 1,
        icon: <FaUsers />,
        title: "Collaborative Teamwork",
        description: "Work together seamlessly in our laundry team. Embrace a supportive environment that values collaboration and mutual success.",
    },
    {
        id: 2,
        icon: <FaTools />,
        title: "Skill Enhancement",
        description: "Sharpen your laundry skills and knowledge. Benefit from skill development opportunities to enhance your expertise in garment care.",
    },
    {
        id: 3,
        icon: <FaCheckCircle />,
        title: "Quality Standards",
        description: "Uphold the highest quality standards in every garment. Ensure excellence in laundry services through rigorous quality assurance.",
    },
    {
        id: 4,
        icon: <FaClock />,
        title: "Efficient Processes",
        description: "Contribute to streamlined and efficient laundry operations. Maximize productivity while maintaining the highest standards of service.",
    },
    {
        id: 5,
        icon: <FaChartLine />,
        title: "Team Advancement",
        description: "Grow together as a laundry team. Enjoy opportunities for career advancement and personal growth within our dynamic work environment.",
    },
    {
        id: 6,
        icon: <FaLeaf />,
        title: "Eco-Friendly Initiatives",
        description: "Promote eco-friendly laundry practices. Contribute to environmental sustainability and a greener future through our laundry initiatives.",
    },
];


const positions = [
{
    id: 1,
    image: images.position1,
    title: 'Laundry Specialist',
    details: {
        location: 'LaundryHub, City',
        timing: 'Full Time',
        hours: 'Flexible Business Hours',
        experience: 'Preferred: 1+ Years in Laundry or Dry Cleaning Services',
        position: 'Multiple Positions Available',
        days: 'Monday to Saturday',
        salary: '$25K - $35K',
        deadline: 'Apply Now - Open Until Filled',
        number: 'For Assistance: Call 123-456-7890',
    },
    overviews: [
        'Join our team as a Laundry Specialist and contribute to delivering top-quality garment care. You will be responsible for processing laundry loads, operating equipment, and ensuring customer satisfaction through consistent service quality.',
    ],
    responsibilities: [
        'Sort, wash, dry, and fold various types of garments and linens.',
        'Operate commercial laundry machines and follow correct procedures.',
        'Inspect clothes for stains, damage, or special care instructions.',
        'Apply appropriate cleaning methods such as dry cleaning or spot treatments.',
        'Maintain cleanliness and organization in the laundry workspace.',
        'Ensure all garments meet quality standards before delivery or pickup.',
    ],
    qualifications: [
        'High school diploma or equivalent preferred.',
        '1+ years of experience in laundry, dry cleaning, or related field.',
        'Familiarity with laundry equipment and garment care practices.',
        'Attention to detail and commitment to service quality.',
        'Ability to work efficiently in a fast-paced environment.',
        'Physical stamina for standing, lifting, and repetitive tasks.',
    ],
},
{
    id: 2,
    image: images.position2,
    title: 'Cleaning Technician',
    details: {
        location: 'LaundryHub, City',
        timing: 'Full Time',
        hours: 'Flexible Business Hours',
        experience: 'Preferred: 1+ Years in Commercial or Residential Cleaning',
        position: 'Multiple Positions Available',
        days: 'Monday to Saturday',
        salary: '$28K - $38K',
        deadline: 'Apply Now - Open Until Filled',
        number: 'For Assistance: Call 123-456-7890',
    },
    overviews: [
        'As a Cleaning Technician at LaundryHub, you will be responsible for maintaining cleanliness and hygiene in all operational areas. Your attention to detail will ensure a safe, sanitary, and pleasant environment for both staff and customers.',
    ],
    responsibilities: [
        'Clean and sanitize workstations, equipment, and customer areas regularly.',
        'Follow cleaning schedules and checklists for daily, weekly, and monthly tasks.',
        'Use appropriate cleaning agents and tools in a safe manner.',
        'Report any maintenance or safety issues to the supervisor.',
        'Assist in organizing laundry supplies and keeping storage areas tidy.',
        'Comply with company hygiene, health, and safety policies.',
    ],
    qualifications: [
        'High school diploma or equivalent preferred.',
        '1+ years of experience in cleaning or janitorial services.',
        'Knowledge of cleaning chemicals and equipment.',
        'Strong work ethic and time management skills.',
        'Ability to work independently and take initiative.',
        'Physical ability to perform repetitive tasks and lift cleaning equipment.',
    ],
},
{
    id: 3,
    image: images.position3,
    title: 'Quality Inspector',
    details: {
        location: 'LaundryHub, City',
        timing: 'Full Time',
        hours: 'Standard Business Hours',
        experience: 'Preferred: 2+ Years in Quality Control or Garment Inspection',
        position: 'Limited Positions Available',
        days: 'Monday to Friday',
        salary: '$35K - $45K',
        deadline: 'Apply Now - Open Until Filled',
        number: 'For Assistance: Call 123-456-7890',
    },
    overviews: [
        'The Quality Inspector ensures that all laundered garments meet our strict standards for cleanliness, appearance, and handling. This role is key to maintaining customer satisfaction and delivering excellence in every order.',
    ],
    responsibilities: [
        'Inspect cleaned garments for stains, tears, or damage before packaging.',
        'Verify that each item meets company quality standards.',
        'Record and report any defects or irregularities found during inspection.',
        'Coordinate with laundry and pressing teams for rework if needed.',
        'Maintain detailed logs of inspection results and item tracking.',
        'Assist in developing and improving quality control processes.',
    ],
    qualifications: [
        'High school diploma or equivalent required.',
        '2+ years of experience in quality assurance or inspection, preferably in laundry, textiles, or manufacturing.',
        'Strong attention to detail and organizational skills.',
        'Ability to recognize various fabric types and appropriate care.',
        'Basic computer or data entry skills for reporting.',
        'Commitment to maintaining high-quality service and standards.',
    ],
},
{
    id: 4,
    image: images.position4,
    title: 'Customer Service',
    details: {
        location: 'LaundryHub, City',
        timing: 'Full Time',
        hours: 'Standard Business Hours',
        experience: 'Preferred: 1+ Years in Customer Support or Service Roles',
        position: 'Multiple Positions Available',
        days: 'Monday to Saturday',
        salary: '$30K - $40K',
        deadline: 'Apply Now - Open Until Filled',
        number: 'For Assistance: Call 123-456-7890',
    },
    overviews: [
        'As a Customer Service representative, you’ll be the first point of contact for our clients, ensuring a smooth and friendly experience. Your role is crucial in maintaining customer satisfaction, handling inquiries, and providing solutions quickly and professionally.',
    ],
    responsibilities: [
        'Handle incoming calls, messages, and in-person queries with professionalism.',
        'Provide accurate information about laundry services, pricing, and turnaround times.',
        'Address customer complaints or concerns and escalate complex issues when needed.',
        'Coordinate with laundry and delivery teams to ensure timely service.',
        'Maintain up-to-date customer records and service notes.',
        'Promote service packages, offers, and loyalty programs.',
    ],
    qualifications: [
        'High school diploma or equivalent; additional training in customer service is a plus.',
        'Minimum of 1 year experience in a customer-facing role.',
        'Excellent verbal and written communication skills.',
        'Proficiency in using computer systems and CRM software.',
        'Problem-solving attitude and ability to multitask.',
        'Friendly, patient, and professional demeanor at all times.',
    ],
},
{
    id: 5,
    image: images.position5,
    title: 'Delivery Driver',
    details: {
        location: 'LaundryHub, City',
        timing: 'Full Time',
        hours: 'Flexible Hours with Morning & Evening Routes',
        experience: 'Preferred: 1+ Years in Delivery or Logistics',
        position: 'Multiple Positions Available',
        days: 'Monday to Saturday',
        salary: '$32K - $45K',
        deadline: 'Apply Now - Open Until Filled',
        number: 'For Assistance: Call 123-456-7890',
    },
    overviews: [
        'As a Delivery Driver, you will be responsible for timely and safe pickup and delivery of laundry orders. You’ll represent LaundryHub with professionalism and ensure excellent customer interactions during every drop-off and collection.',
    ],
    responsibilities: [
        'Pick up and deliver laundry orders to and from customer locations on time.',
        'Ensure the safe transport of garments and packages.',
        'Maintain accurate delivery records and collect payments or confirmations if required.',
        'Inspect the vehicle before and after each trip and report maintenance needs.',
        'Provide friendly and professional service during all customer interactions.',
        'Follow assigned routes and time schedules efficiently.',
    ],
    qualifications: [
        'Valid driver’s license with a clean driving record.',
        'Minimum of 1 year experience in delivery or logistics.',
        'Familiarity with local roads and GPS navigation tools.',
        'Good communication and time management skills.',
        'Physically capable of loading and unloading laundry bags.',
        'Punctual, responsible, and customer-focused.',
    ],
},
{
    id: 6,
    image: images.position6,
    title: 'Equipment Operator',
    details: {
        location: 'LaundryHub, City',
        timing: 'Full Time',
        hours: 'Standard Business Hours',
        experience: 'Preferred: 2+ Years Operating Laundry Equipment',
        position: 'Multiple Positions Available',
        days: 'Monday to Friday',
        salary: '$40K - $55K',
        deadline: 'Apply Now - Open Until Filled',
        number: 'For Assistance: Call 123-456-7890',
    },
    overviews: [
        'Operate and maintain laundry machinery to ensure efficient and safe processing of garments. Equipment Operators play a key role in maintaining high productivity and minimizing downtime in laundry operations.',
    ],
    responsibilities: [
        'Set up and operate industrial laundry machines such as washers, dryers, and presses.',
        'Perform routine maintenance and cleaning on equipment.',
        'Monitor machinery performance and troubleshoot minor issues.',
        'Follow safety protocols to ensure a secure working environment.',
        'Assist in loading and unloading laundry materials.',
        'Report any major malfunctions or repair needs to the maintenance team.',
    ],
    qualifications: [
        'High school diploma or equivalent.',
        'Minimum 2 years experience in operating laundry or industrial equipment.',
        'Knowledge of laundry machinery functions and safety procedures.',
        'Mechanical aptitude and problem-solving skills.',
        'Ability to work independently and in a team.',
        'Physically able to handle equipment and laundry loads.',
    ],
}

];

export { positions, benefits, careerIntro };